import React from "react";
import { Route, Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
    return localStorage.getItem("token-api") ? (
         children
    ) : (
         <Navigate to={{ pathname: "/login" }} />
    )
    

    };

export default AdminRoute;